export default __webpack_public_path__ + "60411dc00f4aeaa04044c0529800389d.png";